import moment from 'moment';
import { HOURS_PARAM } from 'common/constants/constants';
import { formatReviewTimeDaysAndHours } from 'views/root/views/home/views/settings/views/Notifications/notifications.service';

export const ALERT_TYPES = {
  HANGING_PR_WITHOUT_REVIEW_EVALUATION: {
    type: 'pr_hanging',
    alert_title: 'Awaiting review',
    time_format: alert =>
      formatReviewTimeDaysAndHours(
        moment().diff(alert.pr_created_at, HOURS_PARAM)
      )
  },
  REVIEW_TOO_LONG_PULL_REQUEST_EVALUATION: {
    type: 'long_review',
    alert_title: 'Long review',
    time_format: alert =>
      formatReviewTimeDaysAndHours(
        moment().diff(alert.pr_first_commented_at, HOURS_PARAM)
      )
  }
};
